import React from 'react';
import { withStyles } from "@mui/styles";
import {Avatar, IconButton} from '@mui/material';
import CloseIcon from "@mui/icons-material/Close";
import {API_ROOT} from "../../../../../baseUrls";

const styles = {
  topBar: {
    display: "flex",
    borderRadius: "4px 4px 0 0"
  },
  topBarSolid: {
    display: "flex",
    backgroundColor:'rgb(0, 89, 133)',
    color: 'rgba(255,255,255,0.87)',
    fontWeight: 600,
    fontSize: '1rem',
    overflow: 'visible',
    height: '34px',
    borderRadius: "4px 4px 0 0"
  },
  topBarMd: {
    fontSize: '0.85rem',
    maxHeight: '28px',
    '& > div > div:first-child':{
      width:'28px',
      height:'28px',
      margin: "0px 0 0 1px",
      '& > div':{
        width:'24px',
        height:'24px',
      }
    }
  },
  topBarSm: {
    fontSize: '0.7225rem',
    maxHeight: '20px',
    '& > div > div:first-child':{
      border: "2px solid rgb(0, 89, 133)",
      width:'24px',
      height:'24px',
      margin: "0px 0 0 1px",
      '& > div':{
        width:'20px',
        height:'20px',
      }
    },
    '& > div > div:last-child > div':{
      textOverflow:'clip'
    }
  },
  mindfile: {
    display:"flex",
    gap:'0.5em',
    fontSize: '0.85em',
    width: "100%",
    borderRadius: "4px 4px 0 0"
  },
  avatarBorder:{
    border: "3px solid rgb(0, 89, 133)",
    borderRadius:'50%',
    margin: "2px 0 0 3px",
    width:"32px",
    height:"32px",
    zIndex: 1,
  },
  avatar: {
    border: "2px solid rgba(255, 255, 255, 0.87)",
    width:'28px',
    height:'28px',
  },
  mindfileNameWrap: {
    overflow:"hidden",
    height:'100%',
    display:'flex',
    alignItems:'center',
    marginRight: "0.5em"
  },
  mindfileName: {
    textOverflow:'ellipsis',
    overflow:"hidden",
    whiteSpace: "nowrap",
  },
  close:{
    margin:'2px 2px -16px auto',
    overflow: 'visible',
    zIndex:'10'
  },
  closeIcon:{
    color:"inherit"
  }
};

function MindfileAvatarTopBar(props) {
  const { item, size, handleClose, mindfileDisplay, classes, ...divProps } = props;
  const [mindfileName, mindfileTs] = !!mindfileDisplay ? mindfileDisplay : [item.mindfile_name, item.mindfile_ts]
  const topStyle = !!mindfileTs ? classes.topBarSolid : classes.topBar;
  const topSize = size === "Medium" ? classes.topBarMd : size === "Small" ? classes.topBarSm : "";

  return (
    <div className={`${topStyle} ${topSize}`} {...divProps}>
      {!mindfileTs ? null :
        <div className={classes.mindfile}>
          <div className={classes.avatarBorder}>
            <Avatar
              id="mindfileAvatar"
              alt={mindfileName}
              src={`${API_ROOT}/mindfiles/${item.mindfile_id}/avatar/thumbnail?size=48&ts=${mindfileTs}`}
              className={classes.avatar}
            />
          </div>
          <div className={classes.mindfileNameWrap}>
            <div id="mindfileName" className={classes.mindfileName}>
              {mindfileName}
            </div>
          </div>
        </div>
      }
      { !!handleClose ?
        <div className={classes.close}>
          {/* todo: icon small */}
          <IconButton id="xCloseButton" onClick={handleClose} size="small" className={classes.closeIcon}>
            <CloseIcon />
          </IconButton>
        </div>
        : null
      }
    </div>
  );
}

export default withStyles(styles)(MindfileAvatarTopBar);
